export default "__VITE_ASSET__Cb8DqC3z__"